import { makeStyles, tokens } from '@fluentui/react-components';

export const useCommandButtonsStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  button: {
    minWidth: 'unset',
    // Icon-only header buttons render as a fixed 3rem × 3rem square,
    // independent of Fluent's text-button size variants.
    width: '3rem',
    height: '3rem',
    color: tokens.colorNeutralForegroundOnBrand,
    ':hover': {
      color: tokens.colorNeutralForegroundOnBrand,
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
});
